import "./HeavyUpEnrollmentPage.scss";
import React from "react";
import { Link } from "react-router-dom";
import Header from "../../components/ui/StickyHeader";
import TextBlock from "../../components/ui/TextBlock";
import SiteFooter from "../../components/ui/SiteFooter";
import { hero, collageImage, programVideo, plans } from "./heavyUpContent";

const VIDEO_POSTER_TIME_SECONDS = 1;

const HeavyUpEnrollmentPage = () => {
	React.useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="heavy-up-page">
			<Header enrollScrollTargetId="plans" />

			<div className="hero-container heavy-up-hero">
				<div className="hero-content-container">
					<TextBlock
						hat="Land Rover Retailer Program"
						title={
							<>
								Your retailer-specific
								<br />
								heavy up plan
							</>
						}
						type="h1"
						color="black"
						align="left"
					/>
					<TextBlock
						paragraph="Turn your biggest digital opportunity into more sales. Land Rover and Constellation use your retailer's website performance and sales data to identify the primary opportunity limiting growth — and align the right Heavy Up plan to it."
						type="custom"
						color="black"
						align="left"
						fontWeight={280}
						fontSize={20}
					/>
					<div className="button-container">
						<a href="#plans" className="button black_button large_button">
							Choose your plan
						</a>
					</div>
				</div>
				<img
					src={hero.image}
					alt={hero.imageAlt}
					className="hero-image"
				/>
			</div>

			<section className="hu-video-section">
				<div className="hu-video-inner global-padding">
					<div className="hu-video-card">
						<video
							className="hu-video-card__video"
							src={programVideo}
							controls
							playsInline
							preload="auto"
							onLoadedMetadata={(e) => {
								e.currentTarget.currentTime =
									VIDEO_POSTER_TIME_SECONDS;
							}}
						/>
					</div>
				</div>
			</section>

			<section className="hu-investment-section global-padding">
				<TextBlock
					hat="Retailer-Specific Consulting"
					title="Investment built around your greatest opportunity"
					type="sectionHeader"
					color="black"
					align="left"
				/>

				<p className="hu-body">
					Constellation has sales, RDR, and website traffic data by
					retailer. Using this information, we have designed a
					consulting package that is not one-size-fits-all.
				</p>
				<p className="hu-body">
					Heavy Up budgets are tailored to each retailer. Every
					retailer is evaluated based on{" "}
					<strong>
						sales, qualified traffic, inventory engagement, lead
						yield, and funnel efficiency
					</strong>
					. This data determines whether the retailer needs a{" "}
					<strong>
						$3K Demand Capture Plan, a $5K Growth Plan, or a $7.5K
						Acceleration Plan
					</strong>
					, as well as the appropriate media mix across paid search,
					social, and programmatic.
				</p>

				<div className="hu-goal-callout">
					<span className="hu-goal-callout__eyebrow">The Goal</span>
					<h3>
						Fund each retailer&rsquo;s greatest opportunity — not
						simply buy more traffic.
					</h3>
					<p>
						Retailers with strong demand but weaker conversion
						receive a focused capture plan, while retailers with
						proven engagement and conversion readiness receive
						additional investment to scale.
					</p>
				</div>

				<p className="hu-body">
					Budgets and model allocations are then adjusted based on{" "}
					<strong>
						Defender and Range Rover Sport inventory, performance,
						and incremental sales opportunity
					</strong>
					.
				</p>
			</section>

			<section className="hu-collage-section global-padding">
				<img
					src={collageImage}
					alt="Land Rover retailer ad creative across Defender, Discovery, and Range Rover models"
					className="hu-collage-image"
					loading="lazy"
				/>
			</section>

			<section id="plans" className="hu-plans-section">
				<div className="hu-plans-inner global-padding">
					<TextBlock
						hat="Heavy Up Enrollment"
						title="Choose your Heavy Up plan"
						paragraph="Select the package that best addresses your retailer's opportunity. Once selected, complete your retailer information directly on this page to submit enrollment."
						type="sectionHeader"
						color="black"
						align="center"
					/>

					<div className="hu-plans-grid">
						{plans.map((plan) => (
							<article className="hu-plan-card" key={plan.id}>
								<span className="hu-plan-card__index">
									{plan.index}
								</span>
								<h3 className="hu-plan-card__title">
									{plan.title}
								</h3>
								<p className="hu-plan-card__price">
									Starting at <strong>{plan.price}</strong>
									/month
								</p>
								<p className="hu-plan-card__desc">
									{plan.description}
								</p>
								<p className="hu-plan-card__note">
									Tactics will be selected based off
									retailer needs.
								</p>
								<ul className="hu-plan-card__features">
									{plan.features.map((feature) => (
										<li
											key={feature}
											className={
												feature.startsWith("~")
													? "hu-plan-card__feature--muted"
													: undefined
											}>
											{feature.replace(/^~/, "")}
										</li>
									))}
								</ul>
								<Link
									to={`/heavy-up-enrollment/enroll?plan=${plan.id}`}
									className="button black_button fill_button hu-plan-card__cta">
									{plan.cta}
								</Link>
							</article>
						))}
					</div>
				</div>
			</section>

			<SiteFooter dark>
				<p>Land Rover Heavy Up Program</p>
				<p>Program support: jlr@helloconstellation.com</p>
			</SiteFooter>
		</div>
	);
};

export default HeavyUpEnrollmentPage;
